
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DatePicker from '@/components/date-picker.vue';
  import TimePicker from '@/components/TimePicker.vue';
  import GeneratorDialog from '@/components/Admin/GeneratorDialog.vue';
  import DlgEventTemplateDelete from '@/modules/admin/events/_components/DlgEventTemplateDelete.vue';
  import DlgEventTemplateCopyFrom from '@/modules/admin/events/_components/DlgEventTemplateCopyFrom.vue';
  import {withFreshBlockIds} from '@/modules/admin/events/_components/templateBlocks';

  @Component({
    components: {DlgEventTemplateDelete, DlgEventTemplateCopyFrom, GeneratorDialog, TimePicker, DatePicker, Card},
  })
  export default class EventTemplates extends Vue {
    public $refs!: {
      newTemplate: any,
    };
    @Prop({type: Object, default: null}) private event!: any;

    @Action('admin/events/readTemplates') private readTemplates!: (params: any) => Promise<any>;
    @Action('admin/events/createTemplate') private createTemplate!: (params: any) => Promise<any>;
    @Action('admin/events/updateTemplate') private actionUpdateTemplate!: (params: any) => Promise<any>;

    @Getter('admin/events/templates') private templates!: any;

    private loading: boolean = false;
    private copyingId: string | null = null;

    private async mounted() {
      this.loading = true;
      await this.readTemplates({id: this.event.id});
      this.loading = false;
    }


    private async saveTemplate(elem) {
      this.loading = true;
      const template = {
        title: elem.title,
        subject: elem.subject,
        html: elem.html,
        template: elem.object,
      };
      const success = await this.createTemplate({id: this.event.id, template});
      if (success) {
        this.$refs.newTemplate.dialog = false;
        await this.readTemplates({id: this.event.id});
      }
      this.$refs.newTemplate.loading = false;
      this.loading = false;
    }

    private async updateTemplate(elem) {
      this.loading = true;
      const template = {
        id: elem.id,
        title: elem.title,
        subject: elem.subject,
        html: elem.html,
        template: elem.object,
      };
      await this.actionUpdateTemplate({id: this.event.id, template});
      await this.readTemplates({id: this.event.id});
      this.loading = false;
    }

    private async copyTemplate(t: any) {
      if (this.copyingId) {
        return;
      }
      this.copyingId = t.id;
      const template = {
        title: `Kopie von ${t.title}`,
        subject: t.subject,
        html: t.html,
        template: withFreshBlockIds(t.template),
      };
      const success = await this.createTemplate({id: this.event.id, template});
      if (success) {
        await this.readTemplates({id: this.event.id});
      }
      this.copyingId = null;
    }

    private async onTemplateCopied() {
      await this.readTemplates({id: this.event.id});
    }
  }
